import React, { useState, useEffect } from 'react';
import { FaVideo, FaSearch } from 'react-icons/fa';
import SEO from './components/SEO';
import './Song.css';

export default function Playlists() {
  const [playlists, setPlaylists] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPlaylistId, setCurrentPlaylistId] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);

  // GCC Worship channel ID and provided API key
  const channelId = 'UCdtaCSCH4gtibrDZ_Biwqxw';
  const apiKey = 'AIzaSyDFpywWkCr0T_7cgwdzR14326xBMoTmeFE';

  useEffect(() => {
    const fetchPlaylists = async () => {
      try {
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlists?part=snippet&channelId=${channelId}&maxResults=50&key=${apiKey}`
        );
        const data = await response.json();
        if (data.items) {
          const filtered = data.items.filter(item =>
            !item.snippet.title.toLowerCase().includes('karaoke')
          );
          const mapped = filtered.map(item => {
            const thumbs = item.snippet.thumbnails;
            const image = (thumbs.high && thumbs.high.url) ||
                          (thumbs.medium && thumbs.medium.url) ||
                          (thumbs.default && thumbs.default.url) || '';
            return {
              id: item.id,
              title: item.snippet.title,
              description: item.snippet.description || 'No description available.',
              image,
            };
          });
          setPlaylists(mapped);
        } else {
          console.error('No playlists returned', data);
        }
      } catch (err) {
        console.error('Error fetching playlists:', err);
      }
    };
    fetchPlaylists();
  }, [channelId, apiKey]);

  useEffect(() => {
    if (currentPlaylistId) {
      setVideoUrl(`https://www.youtube.com/embed/videoseries?list=${currentPlaylistId}&autoplay=1&mute=0`);
    }
  }, [currentPlaylistId]);

  const filteredPlaylists = playlists.filter(pl =>
    pl.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="media-container">
      <SEO
        title="GCC Playlists"
        description="Playlists from GCC Worship"
      />
      <div className="media-header">
        <h1 className="media-heading">
          <FaVideo className="media-icon" /> Playlists
        </h1>
        <p className="media-intro">Browse all playlists from GCC Worship.</p>
      </div>

      <form
        className="playlist-search-form search-form"
        onSubmit={(e) => e.preventDefault()}
      >
        <input
          type="text"
          className="search-input"
          placeholder="Search playlists"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
        />
        <button type="submit" className="search-button">
          <FaSearch />
        </button>
      </form>

      {currentPlaylistId ? (
        <div className="video-container">
          {videoUrl ? (
            <iframe
              src={videoUrl}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="YouTube Playlist"
            ></iframe>
          ) : (
            <p>Loading...</p>
          )}
          <button className="back-button" onClick={() => setCurrentPlaylistId(null)}>
            Back to Playlists
          </button>
        </div>
      ) : (
        <div className="playlist-grid">
          {filteredPlaylists.map(pl => (
            <div
              key={pl.id}
              className="playlist-item"
              onClick={() => setCurrentPlaylistId(pl.id)}
            >
              {pl.image && (
                <img
                  src={pl.image}
                  alt={`${pl.title} Thumbnail`}
                  className="playlist-image"
                />
              )}
              <h3 className="playlist-title">{pl.title}</h3>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
